import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const SEOIntentLanding = lazy(() => import("@/pages/SEOIntentLanding"));

export const Route = createFileRoute("/san-jose-singles-dinners")({
  component: SEOIntentLanding,
});
